import MptcfeUtils from 'mptcfe-utils'

const CallApp = MptcfeUtils.CallApp
/**
 * @description 判断唤起APP是否成功的延时时间
 */
const CALLAPPDELAYTIME = 3 * 1000

const getExplorerInfo = () => {
    try {
        let explorer = window.navigator.userAgent;
        explorer = explorer.toLowerCase();
        //ie
        if (explorer.indexOf("msie") >= 0) {
            let ver = explorer.match(/msie ([\d.]+)/)[1] || "";
            return "IE" + ver;
        }
        //firefox
        else if (explorer.indexOf("firefox") >= 0) {
            let ver = explorer.match(/firefox\/([\d.]+)/)[1] || "";
            return "Firefox" + ver;
        }
        //Chrome
        else if (explorer.indexOf("chrome") >= 0) {
            let ver = explorer.match(/chrome\/([\d.]+)/)[1] || "";
            return "Chrome" + ver;
        }
        //Opera
        else if (explorer.indexOf("opera") >= 0) {
            let ver = explorer.match(/opera.([\d.]+)/)[1] || "";
            return "Opera" + ver;
        }
        //Safari
        else if (explorer.indexOf("safari") >= 0) {
            if (explorer.indexOf('CriOS') >= 0) {
                return "ios_chrome"
            } else {
                let ver = explorer.match(/version\/([\d.]+)/)[1] || "";
                return "Safari" + ver;
            }
        }
        if (explorer.indexOf("edge") >= 0) {
            let ver = explorer.match(/edge\/([\d.]+)/)[1] || "";
            return "edge" + ver;
        }
        //遨游浏览器
        if (explorer.indexOf("maxthon") >= 0) {
            let ver = explorer.match(/maxthon\/([\d.]+)/)[1] || "";
            return "aoyou" + ver;
        }
        //QQ浏览器
        if (explorer.indexOf("qqbrowser") >= 0) {
            let ver = explorer.match(/qqbrowser\/([\d.]+)/)[1] || "";
            return "qq" + ver;
        }
        //搜狗浏览器
        if (explorer.indexOf("se 2.x") >= 0) {
            return "sogou";
        }

        return "other";
    } catch (err) {
        return "unknown"
    }
}
const downloadApk = (acode, downloadURL) => {
    const timeout = 3 * 1000 // 3s之后如果h5被隐藏，则证明唤起成功了
    const _callUniqueId = MptcfeUtils.Utils.getPvId()

    setTimeout(() => {
        if (!document.hidden) {
            // 点击打开app下载apk事件
            MptcfeUtils.Utils.sendSpmAction(acode, `callId:${_callUniqueId}`)
            window.location.href = downloadURL
        }
    }, timeout);
}
const DirectCallApp = (url) => {
    /**
     * @description 对应上报参数，callId
     */

    //唤起APP操作
    new CallApp({
        protocol: {
            intent: url,
            schema: url,
            universalLink: url,
        },
        timeout: CALLAPPDELAYTIME,
    }).call()
}
export default {
    openApp: (clickACode, downloadACode, deepLink, jumpURL) => {
        // 点击打开搜狐新闻按钮事件码
        const _callUniqueId = MptcfeUtils.Utils.getPvId()
        MptcfeUtils.Utils.sendSpmAction(clickACode, `callId:${_callUniqueId}`)
        DirectCallApp(deepLink)
        // downloadApk(downloadACode, downloadURL)
        setTimeout(() => {
            location.href = jumpURL
        }, 250) // 延迟250ms执行唤起
    },
    getExplorerInfo,

}